<template>
    <div class="mt-16 px-6 h-full flex flex-col">
        <h2 class="text-2xl font-bold">{{ t('confirm_header') }}</h2>
        <p v-if="type == 'dangerous_trash'" class="mt-6 text-base">{{ t('confirm_text') }}</p>
        <p v-if="type == 'textile' || type == 'book-in' || type == 'book-out'" class="mt-6 text-base">{{ t('confirm_text_textile') }}</p>
        <div class="max-w-lg mx-auto w-full pt-4 pb-6">
            <Button @click="emitBack()" class="mt-16 text-center" :text="t('back_to_front')"></Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    const { t } = useI18n()
    const emit = defineEmits(["goBack"]);
    const props = defineProps<{
        type: string;
    }>();
    function emitBack() {
        emit("goBack");
    }
</script>